// XXX If IE <= 11 will become necessary to support, enable those:
// require('setimmediate')
// require('promise-polyfill')
// // To add to window
// if (!window.Promise) {
//   window.Promise = Promise
// }

// Ensure window.fetch is a thing
require('whatwg-fetch')

const plugins = {
    'ubhd/gnd': require('./plugin/ubhd-gnd'),
    'gbv/gnd': require('./plugin/gbv-gnd'),
}

module.exports = {

  /**
   * ### AuthoritiesClient.data
   *
   * Static data bundled with the client
   */
  data: require('./data'),

  /**
   * ### AuthoritiesClient.utils
   *
   * Utilities
   */
  utils: require('./utils'),

  /**
   * ### AuthoritiesClient.plugins
   *
   * Map of the plugins available.
   */
  plugins,

  /**
   * ### AuthoritiesClient.plugin(pluginName, pluginOpts)
   *
   * - `@param {string} pluginName` Name of the plugin. See [AuthoritiesClient.plugins](#authoritiesclient-plugins) for a list
   * - `@param {object} pluginOpts` Options passed to the plugin
   * - `@return {object}` Instance of the plugin
   */
  plugin(pluginName, pluginOpts) {
    if (!(pluginName in plugins)) {
      throw new Error(`No such plugin: ${pluginName}`)
    }
    return new plugins[pluginName](pluginOpts)
  }

}
